import { log2 } from "../../utils/log2";
import CHAT_TYPES from "../../utils/ChatTypes";
import { getPendingMessages } from "../../utils/chat";
import {
    chatNameUpdate,
    chatProfilePhotoDelete,
    chatProfilePhotoUpdate,
    deleteGrup,
    extractLinksFromChat,
    getChatMedia,
    getChatsLastMessages,
    leaveChatGroup,
    updateChatStamp,
} from "../../api/team";
import _ from "lodash";
import moment from "moment";
import SYSTEM_PUBSUB from "../../utils/systemPubSub";

const log = log2("team.vuex");
let timerIds = [];
const team = {
    namespaced: true,

    state: {
        chats: [],
        usersPrivateChatChannelMessages: [],
        chatHistory: {},
        activeConversation: null,
        pendingMessages: getPendingMessages(),
        unreadMessages: JSON.parse(localStorage.getItem("chats-time-stamp")) || [
            {
                chatId: null,
                Date: null,
                unreadCount: 0,
            },
        ],
        time: null,
        loadingState: [],
        lastMessages: [],
        selectedChat: null,
        notificationSettings: JSON.parse(localStorage.getItem("notification_settings")) || [],
        typingMessages: [],
        teamChatVisible: false,
    },

    getters: {
        unreadChatCount: (state) => state.unreadMessages.filter((chat) => chat.unreadCount > 0).length,
        isNotificationMute: (state) => (chatId) => {
            const result = state.notificationSettings.find((setting) => setting.chatId === chatId);
            if (!!result) return result.mute;
            else return true;
        },
    },

    mutations: {
        SET_CHATS: async (state, payload) => {
            let teamConversation;
            let myConversation;
            let { chats, lastMessages } = payload;
            state.lastMessages = lastMessages;

            const sortedDatesNew = state.lastMessages.sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate));

            let newChatList = [];
            sortedDatesNew.map((sortedDate, i) => {
                const chat = chats.find((chat) => sortedDate.conversation === chat._id);
                if (chat) {
                    newChatList[i] = chat;
                }
            });

            log("SET_CHATS", newChatList);
            newChatList = newChatList.reduce((acc, chat) => {
                const isTeam = chat.meta.chatType === CHAT_TYPES.TEAM;
                const isMe =
                    chat.meta.chatType === CHAT_TYPES.THREAD &&
                    chat.meta.thread.agent1._id == chat.meta.thread.agent2._id;
                if (isTeam) {
                    teamConversation = chat;
                } else if (isMe) {
                    myConversation = chat;
                } else {
                    acc.push(chat);
                }
                return acc;
            }, []);

            if (!!myConversation) newChatList.unshift(myConversation);
            if (!!teamConversation) newChatList.unshift(teamConversation);

            // yeni oluşturulan chati ekrana getirir
            const oldChatIds = state.chats.map((chat) => {
                log("oldChatIds chat", chat);
                return chat._id.toString();
            });

            const newChatIndex =
                oldChatIds.length !== 0 && oldChatIds.length !== newChatList.length
                    ? newChatList.findIndex((chat) => !oldChatIds.includes(chat._id))
                    : null;

            state.selectedChat = !!newChatIndex && newChatIndex !== -1 ? newChatList[newChatIndex] : newChatList[0];

            log("teamchatupdate-1", newChatList);
            state.chats = newChatList;

            timerIds = state.chats.map((chat) => {
                return chat._id;
            });
            SYSTEM_PUBSUB.publish("CHAT_UPDATED", state.chats);
        },
        SET_CHATS_SELECTED_CHAT: async (state, payload) => {
            let teamConversation;
            let myConversation;

            let { chats, lastMessages } = payload;
            state.lastMessages = lastMessages;

            const sortedDatesNew = state.lastMessages.sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate));

            let newChatList = [];
            sortedDatesNew.map((sortedDate, i) => {
                const chat = chats.find((chat) => sortedDate.conversation === chat._id);
                if (chat) {
                    newChatList[i] = chat;
                }
            });

            newChatList = newChatList.reduce((acc, chat) => {
                if (chat.meta.chatType === CHAT_TYPES.TEAM) {
                    teamConversation = chat;
                } else if (
                    chat.meta.chatType === CHAT_TYPES.THREAD &&
                    chat.meta.thread.agent1._id == chat.meta.thread.agent2._id
                ) {
                    myConversation = chat;
                } else {
                    acc.push(chat);
                }
                return acc;
            }, []);

            if (!!teamConversation) newChatList.unshift(teamConversation);

            log("teamchatupdate-2", newChatList);
            state.chats = newChatList;

            const result = newChatList.filter((chat) => chat._id === state.selectedChat._id)[0];
            if (!result) {
                state.selectedChat = newChatList[0];
            } else {
                state.selectedChat = result;
            }
        },
        UPDATE_UNREAD_CHATS: (state, payload) => {
            state.unreadMessages = JSON.parse(localStorage.getItem("chats-time-stamp")) || payload.chats;
        },
        UPDATE_CHAT_UNREAD: (state, data) => {
            const { payload } = data;
            // ilk önce eski chat ekranı için daha önce storage'e kaydedilmiş ise sadece date'i güncelliyoruz
            // eğer daha önce storage'e kaydedilmemiş ise yeni bir obje oluşturuyoruz
            if (!!payload.oldChatId) {
                const findOldChat = state.unreadMessages.findIndex((chat) => chat.chatId === payload.oldChatId);
                if (findOldChat !== -1) {
                    state.unreadMessages[findOldChat].Date = new Date();
                }
            }

            // bu kısımda açılan yeni chat ekranı için unread değeri 0 olarak set ediliyor
            // eğer unread değeri zaten 0 ise db tarafında bir işlem yapmıyoruz
            const findNewChat = state.unreadMessages.findIndex((chat) => chat.chatId === payload.newChatId);
            if (findNewChat !== -1) {
                state.unreadMessages[findNewChat].Date = new Date();
                state.unreadMessages[findNewChat].unreadCount = 0;
            } else {
                state.unreadMessages.push({
                    chatId: payload.newChatId,
                    Date: new Date(),
                    unreadCount: 0,
                });
            }
            localStorage.setItem("chats-time-stamp", JSON.stringify(state.unreadMessages));

            if (timerIds[payload.newChatId]) {
                clearTimeout(timerIds[payload.newChatId]);
            }
            timerIds[payload.newChatId] = setTimeout(() => {
                // sunucuya gonderilecek
                updateChatStamp({
                    userId: payload.userId,
                    chatId: payload.newChatId,
                    unreadCount: 0,
                });
            }, 50);
        },
        SET_LOADING_FILE: (state, payload) => {
            if (state.loadingState.length === 0) {
                state.loadingState.push(payload);
            } else {
                state.loadingState.map((p) => {
                    if (p.chat_id === payload.chat_id && p.fileNumber === payload.fileNumber) {
                        payload.percent = p.percent;
                    } else {
                        state.loadingState.push(payload);
                    }
                });
            }
        },
        INC_UNREAD_MESSAGE_COUNT: (state, data) => {
            const { rootState, chatId } = data;
            const findChatTimeStamp = state.unreadMessages.findIndex((chat) => chat.chatId === chatId);
            // daha önce görüntülemediği chatler için yeni bir obje oluşturuyoruz
            if (findChatTimeStamp === -1) {
                state.unreadMessages.push({
                    chatId: chatId,
                    Date: new Date(),
                    unreadCount: 1,
                });
            } else {
                state.unreadMessages[findChatTimeStamp].unreadCount += 1;
                state.unreadMessages[findChatTimeStamp].Date = new Date();
            }
            localStorage.setItem("chats-time-stamp", JSON.stringify(state.unreadMessages));

            const findIndex = timerIds.findIndex((chat) => chat.chatId === chatId);
            if (timerIds[findIndex]) {
                clearTimeout(timerIds[findIndex]);
            }
            timerIds[findIndex] = setTimeout(() => {
                // sunucuya gonderilecek
                updateChatStamp({
                    chatId,
                    userId: rootState.auth.user._id,
                    unreadCount:
                        findChatTimeStamp !== -1
                            ? state.unreadMessages[findChatTimeStamp].unreadCount
                            : state.unreadMessages[state.unreadMessages.length - 1].unreadCount,
                });
            }, 5000);
        },
        UPDATE_CHAT_LAST_MESSAGE: (state, payload) => {
            const lastMessageIndex = state.lastMessages.findIndex((p) => p.conversation === payload.chatId);
            if (lastMessageIndex !== -1) {
                state.lastMessages[lastMessageIndex].description = payload.message;
                state.lastMessages[lastMessageIndex].createdDate = new Date();
            } else {
                state.lastMessages.push({
                    conversation: payload.chatId,
                    description: payload.message,
                    createdDate: new Date(),
                });
            }

            //#region RE-ORDER CHATS
            /**
             * ilk sırada her zaman team chat
             * ikinci sırada her zaman benim chatim
             * sonrasıkiler en son mesaj atılandan güncelden eskiye doğru gider
             *@todo MuhammedAli burayı ayrı bir fonksiyon haline getirip kullanabilirsin
             */
            const teamChat = state.chats.find((chat) => chat.meta.chatType === CHAT_TYPES.TEAM);
            const meChat = state.chats.find(
                (chat) =>
                    chat.meta.chatType === CHAT_TYPES.THREAD &&
                    chat.meta.thread.agent1._id === chat.meta.thread.agent2._id
            );
            const others = _.orderBy(
                state.chats
                    .filter((chat) => ![teamChat._id, meChat._id].includes(chat._id))
                    .map((chat) => {
                        chat.lastMessageTS =
                            state.lastMessages.find((p) => p.conversation === chat._id)?.createdDate ||
                            chat.createdDate;
                        chat.lastMessageTS = moment(chat.lastMessageTS).valueOf();
                        return chat;
                    }),
                ["lastMessageTS"],
                ["desc"]
            );

            const result = [teamChat, meChat, ...others].filter(Boolean);
            log("UPDATE_CHAT_LAST_MESSAGE", {
                payload,
                lastMessages: state.lastMessages,
                chats: state.chats,
                teamChat,
                meChat,
                others,
                result,
            });
            log("teamchatupdate-3", result);
            state.chats = result;
            //#endregion
        },
        SELECTED_CHAT_CHANGE: (state, payload) => {
            state.selectedChat = payload;
        },
        NOTIFICATION_SETTING: (state, payload) => {
            const { chatId, mute } = payload;
            const isChat = state.notificationSettings.filter((p) => p.chatId === chatId);
            if (isChat.length === 0) {
                state.notificationSettings.push({
                    chatId,
                    mute,
                });
            } else {
                state.notificationSettings = state.notificationSettings.map((p) => {
                    if (p.chatId === chatId) {
                        p.mute = mute;
                    }
                    return p;
                });
            }
            localStorage.setItem("notification_settings", JSON.stringify(state.notificationSettings));
        },
        TYPING_MESSAGE: (state, payload) => {
            const isMessage = state.typingMessages.filter((p) => p.chatId === payload.chatId);
            if (isMessage.length === 0) {
                state.typingMessages.push(payload);
            } else {
                state.typingMessages = state.typingMessages.map((p) => {
                    if (p.chatId === payload.chatId) {
                        p.userName = payload.userName;
                        p.message = payload.message;
                    }
                    return p;
                });
            }
        },
        GROUP_PROFILE_PICTURE: (state, payload) => {
            const chatIndex = state.chats.findIndex((chat) => chat._id === payload.chatId);
            if (chatIndex >= 0) {
                log("GROUP_PROFILE_PICTURE", payload);
                state.chats[chatIndex].meta.groupThread.groupProfilePicture = payload.groupProfilePicture;
                state.selectedChat = state.chats[chatIndex];
            }
        },
        CHANGE_TEAM_CHAT_VISIBLE: (state, payload) => {
            state.teamChatVisible = payload;
        },
    },

    actions: {
        changeTeamChatVisible({ commit }, payload) {
            commit("CHANGE_TEAM_CHAT_VISIBLE", payload);
        },
        getLoadingState({ state }, fileNumber) {
            log("getLoadingState", fileNumber);
            const loadingFile = state.loadingState.find((p) => p.fileNumber === fileNumber);
            state.loadingState = state.loadingState.filter((p) => p.fileNumber !== fileNumber);
            return loadingFile ? loadingFile.chat_id : "";
        },
        setLoadingState({ commit }, payload) {
            log("setLoadingState", payload);
            commit("SET_LOADING_FILE", payload);
        },
        updateChatLastMessage({ commit }, payload) {
            commit("UPDATE_CHAT_LAST_MESSAGE", payload);
        },
        getLoadingFilePercent({ state }, chat_id) {
            log("getLoadingState", chat_id);
            const loadingFile = state.loadingState.find((p) => p.chat_id === chat_id);
            return loadingFile ? loadingFile.percent : "";
        },
        async setPrivateChats({ commit }, chats) {
            const chatIds = chats.map((item) => item._id);
            const lastMessages = await getChatsLastMessages({ chatIds }).then((res) => res.data);
            commit("SET_CHATS", {
                chats,
                lastMessages,
            });
        },
        async setPrivateChatsSelectedChat({ commit }, chats) {
            const chatIds = chats.map((item) => item._id);
            const lastMessages = await getChatsLastMessages({ chatIds }).then((res) => res.data);
            commit("SET_CHATS_SELECTED_CHAT", {
                chats,
                lastMessages,
            });
        },
        async setUnreadChats({ commit }, chats) {
            commit("UPDATE_UNREAD_CHATS", { chats: chats });
        },
        async updateUnreadMessageCount({ commit, rootState }, payload) {
            commit("UPDATE_CHAT_UNREAD", {
                rootState,
                payload: {
                    oldChatId: payload.oldChatId,
                    newChatId: payload.newChatId,
                    userId: payload.userId,
                },
            });
        },
        async increaseUnreadMessageCount({ commit, rootState }, chatId) {
            commit("INC_UNREAD_MESSAGE_COUNT", { rootState, chatId });
        },
        async chatNameUpdate({ commit }, payload) {
            await chatNameUpdate(payload).then((res) => {});
        },
        async leaveChatGroup({ commit }, payload) {
            await leaveChatGroup(payload).then((res) => {});
        },
        getChatMedia({ commit }, payload) {
            return getChatMedia(payload).then((res) => res.data);
        },
        extractLinksFromChat({ commit }, payload) {
            return extractLinksFromChat(payload).then((res) => res.data);
        },
        async selectedChatChange({ commit }, payload) {
            commit("SELECTED_CHAT_CHANGE", payload);
        },
        async notificationSetting({ commit }, payload) {
            commit("NOTIFICATION_SETTING", payload);
        },
        typingMessages({ commit }, payload) {
            commit("TYPING_MESSAGE", payload);
        },
        async groupProfilePicture({ commit }, payload) {
            commit("GROUP_PROFILE_PICTURE", payload);
        },
        async chatProfilePhotoUpdate({ commit }, payload) {
            return chatProfilePhotoUpdate(payload).then((res) => res.data);
        },
        async deleteGrup({ commit }, payload) {
            return deleteGrup(payload).then((res) => res.data);
        },
        async chatProfilePhotoDelete({ commit }, payload) {
            return chatProfilePhotoDelete(payload).then((res) => res.data);
        },
    },
};

export default team;
